import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, NO_ERRORS_SCHEMA, OnChanges, Output, signal, ViewChild } from "@angular/core";
import { IMPORTS } from './_imports';
import { Enums } from "src/app/shared/enums";
import { FlowInboxDirectory } from "src/app/models/flow-inbox-directory.model";
import { Utils } from '../../../shared/utils';

@Component({
    selector: 'flow-inbox-directory-item',
    templateUrl: './flow-inbox-directory-item.component.html',
    styleUrl: './flow-inbox-directory-item.component.scss',
    standalone: true,
    imports: IMPORTS,
    schemas: [NO_ERRORS_SCHEMA]
})
export class FlowInboxDirectoryItemComponent implements OnChanges {
    // #region [ViewChild]
    @ViewChild('titleRef') titleRef: ElementRef<HTMLElement>;
    @ViewChild('titleWrapperRef') titleWrapperRef: ElementRef<HTMLElement>;
    // #endregion

    // #region [Type props]
    Enums = Enums;
    // #endregion

    // #region [props]
    overflowCache = false;
    // #endregion

    // #region [signals]
    $flowInboxDirectoryName = signal('');
    $mode = signal(null as Enums.FlowInboxDirectoryMode);
    $flowInboxDirectory = signal(null as FlowInboxDirectory);
    // #endregion

    // #region [Input/Output]
    @Input() _mode: Enums.FlowInboxDirectoryMode;
    @Input() _flowInboxDirectory: FlowInboxDirectory;
    @Output() _openEvent = new EventEmitter<FlowInboxDirectory>();
    @Output() _prepareCreateEvent = new EventEmitter<void>();
    @Output() _confirmEvent = new EventEmitter<string>();
    @Output() _cancelEvent = new EventEmitter<void>();
    @Output() _deleteEvent = new EventEmitter<FlowInboxDirectory>();
    @Output() _actionEvent = new EventEmitter<{ model: FlowInboxDirectory, actionType: Enums.FlowDefinitionItemActionType }>();
    // #endregion

    constructor(
        public element: ElementRef,
        private cd: ChangeDetectorRef
    ) { }

    ngOnChanges() {
        this.$mode.set(this._mode);
        this.$flowInboxDirectory.set(this._flowInboxDirectory);
    }

    isOverflown(elem: HTMLElement): boolean {
        const currentStatus = this.isCurrentlyOverflown(elem);
        if (this.overflowCache != currentStatus) {
            Promise.resolve().then(() => {
                this.overflowCache = currentStatus;
                this.cd.markForCheck();
            });
        }

        return this.overflowCache ?? false;
    }

    open() {
        this._openEvent.emit(this.$flowInboxDirectory());
    }

    executeAction(actionType: Enums.FlowDefinitionItemActionType) {
        this._actionEvent.emit({
            model: this.$flowInboxDirectory(),
            actionType: actionType
        });
    }

    edit() {
        this.$flowInboxDirectoryName.set(this.$flowInboxDirectory().name);
        this.$mode.set(Enums.FlowInboxDirectoryMode.Creating);
    }

    prepareCreation() {
        this._prepareCreateEvent.emit();
    }

    confirm() {
        const newName = this.$flowInboxDirectoryName()?.trim();
        if (Utils.isNullOrEmpty(newName)) return;

        this._confirmEvent.emit(newName);

        if (this.$flowInboxDirectory()?.id) {
            this.$mode.set(Enums.FlowInboxDirectoryMode.Viewing);
        }
    }

    cancel() {
        if (this.$flowInboxDirectory()?.id) {
            this.$mode.set(Enums.FlowInboxDirectoryMode.Viewing);
        } else {
            this._cancelEvent.emit();
        }
    }

    delete() {
        this._deleteEvent.emit(this.$flowInboxDirectory());
    }

    // #region [===== private methods =====]
    // #endregion

    private isCurrentlyOverflown(elem: HTMLElement) {
        let title = this.titleRef?.nativeElement;
        if (title == null) return false;

        return title.offsetWidth > elem.clientWidth;
    };
}
